import { toast } from 'react-toastify';

import { useGetDepartment, usePatchDepartment } from '@vlabs/api/artemy/client';

import { useDetachDepartmentPermissionTagsTranslation } from './i18n';
import type { DetachDepartmentPermissionTagsProps } from './types';

export function useDetachDepartmentPermissionTags({
  departmentId,
  permissionTags,
  onDetach,
}: DetachDepartmentPermissionTagsProps): () => Promise<void> {
  const { t } = useDetachDepartmentPermissionTagsTranslation();
  const getDepartment = useGetDepartment(departmentId);
  const patchDepartment = usePatchDepartment();

  return async (): Promise<void> => {
    const currentTags = getDepartment.data?.permission_tags ?? [];
    const newTags = currentTags.filter((i) => {
      return (i.permission_tag === undefined || !permissionTags.includes(i.permission_tag));
    });

    return patchDepartment.mutateAsync(
      { departmentId, data: { permission_tags: newTags } },
      {
        onSuccess: () => {
          toast.success(t('toast_success'));
          onDetach?.();
        },
        onError: () => {
          toast.error(t('toast_error'));
        },
      },
    );
  };
}
